import genericNotifications, {
  notificationAction,
  notificationTitles,
} from '../../utils/genericNotifications';

export const marketStudiesNotifications = {
  create: (name) =>
    genericNotifications(
      notificationTitles.marketStudies,
      name,
      notificationAction.create,
    ),
  update: (name) =>
    genericNotifications(
      notificationTitles.marketStudies,
      name,
      notificationAction.update,
    ),
  delete: (name) =>
    genericNotifications(
      notificationTitles.marketStudies,
      name,
      notificationAction.delete,
    ),
};

export const marketStudyResultNotifications = {
  update: (name) =>
    genericNotifications(
      notificationTitles.marketStudyResult,
      name,
      notificationAction.update,
    ),
};
